import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73c47394"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-view-with-app-bar" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "cv-user-name d-none d-sm-inline mr-2" }
const _hoisted_4 = { class: "pa-4" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "pa-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cv-eyebrow mb-1" }, "Bejelentkezve", -1))
const _hoisted_8 = { class: "text-body-2 font-weight-medium" }
const _hoisted_9 = { class: "cv-page-body" }

import { onMounted, onUnmounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import logo from "@/assets/logotran2.png";
import NotificationBell from "@/components/layout/NotificationBell.vue";
import { useNotifications } from "@/services/useNotifications";

export type ShellRoute = {
  path: string;
  name: string;
  icon: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'AppShell',
  props: {
    routes: {},
    homePath: {},
    fullName: {},
    portalLabel: {}
  },
  emits: ["logout"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const drawer = ref(false);
const router = useRouter();
const route = useRoute();

// The shell is the only app bar in the app and both portals wrap it, so opening the
// stream here covers admin and customer alike. By the time it mounts the router guard has
// already established who the user is.
const { connect, disconnect } = useNotifications();
onMounted(() => connect());
onUnmounted(() => disconnect());

/** Exact match only: every path is a prefix of the deeper ones under it. */
const isActive = (path: string) => route.path === path;

function navigateTo(routePath: string) {
  router.push(routePath === "" ? "/" : routePath);
  drawer.value = false;
}

function logout() {
  emit("logout");
}

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_app_bar, {
      app: "",
      color: "surface",
      elevation: 0,
      class: "cv-app-bar"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar_nav_icon, {
          variant: "text",
          "aria-label": "Menü",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (drawer.value = !drawer.value), ["stop"]))
        }),
        _createVNode(_component_router_link, {
          to: _ctx.homePath,
          class: "cv-logo-link ml-1"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _unref(logo),
              height: "34",
              alt: "Cégvándor"
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        }, 8, ["to"]),
        (_ctx.portalLabel)
          ? (_openBlock(), _createBlock(_component_v_chip, {
              key: 0,
              size: "small",
              variant: "tonal",
              color: "primary",
              class: "ml-3 d-none d-sm-flex",
              label: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.portalLabel), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_spacer),
        _createVNode(NotificationBell, { class: "mr-1" }),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.fullName), 1),
        _createVNode(_component_v_btn, {
          icon: "mdi-logout",
          variant: "text",
          "aria-label": "Kijelentkezés",
          onClick: logout
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_navigation_drawer, {
      modelValue: drawer.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
      location: _ctx.$vuetify.display.mobile ? 'bottom' : undefined,
      temporary: "",
      class: "cv-drawer"
    }, {
      append: _withCtx(() => [
        _createVNode(_component_v_divider),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.fullName), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _unref(logo),
            height: "30",
            alt: "Cégvándor"
          }, null, 8, _hoisted_5)
        ]),
        _createVNode(_component_v_divider),
        _createVNode(_component_v_list, {
          nav: "",
          density: "comfortable",
          class: "pa-2"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (route) => {
              return (_openBlock(), _createBlock(_component_v_list_item, {
                key: route.path,
                "prepend-icon": route.icon,
                active: isActive(route.path),
                "active-color": "primary",
                rounded: "lg",
                onClick: ($event: any) => (navigateTo(route.path))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(route.name), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["prepend-icon", "active", "onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "location"]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(), _createBlock(_component_router_view, {
        key: _unref(route).path
      }))
    ])
  ]))
}
}

})